import { render, staticRenderFns } from "./minimal.vue?vue&type=template&id=7b9a5870&scoped=true&"
import script from "./minimal.vue?vue&type=script&lang=js&"
export * from "./minimal.vue?vue&type=script&lang=js&"
import style0 from "./minimal.vue?vue&type=style&index=0&id=7b9a5870&prod&lang=scss&"
import style1 from "./minimal.vue?vue&type=style&index=1&id=7b9a5870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9a5870",
  null
  
)

export default component.exports